<template>
  <div class="collapse is-fullwidth">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    isFullwidth: Boolean,
    accordion: Boolean
  },

  computed: {
    $collapseItems () {
      return this.$children.filter(child => child._isCollapseItem)
    }
  },

  methods: {
    openByIndex (index) {
      if (this.accordion) {
        this.$collapseItems.forEach((item, i) => {
          if (i !== index) {
            item.isActived = false
          }
        })
      }
    }
  }

}
</script>

<style>
.collapse.is-fullwidth {
  width: 100%;
}
.card-content{
  padding: 0;
}
.collapse-item .card-content-box{
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// Collapse.vue?3ac43e4e